







import { IUser } from '@/models/IUser.model';
import { Component, Vue } from 'vue-property-decorator';
@Component({
  components: {
  },
})
export default class DevHeaderUser extends Vue {

      selectedUserId: string = '';
      searchTerm: string = '';

      get users(): IUser[] {
        return this.$store.state.users
      }
      get usersIds(): string[] {
        return this.users.map((user: IUser) => user.cc_type + '_' + user.cc_number)
      }

      public onSelect($userId: string):void {
        const user = this.users.find((user: IUser) => user.cc_type + '_' + user.cc_number === $userId);
        this.$store.dispatch('setUser',user);
      }   

      private mounted(){
      }

}
